import React from "react";
import styled from "@emotion/styled";

// Styled Components
const Container = styled.div`
  column-gap: 3em;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media screen and (max-width: 600px) {
    column-gap: unset;
  }
`;

const LinkContainer = styled.div`
  display: inline-block;
  margin-bottom: 16px;
  position: relative;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

const H6 = styled.h6`
  margin-bottom: 8px;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

const StyledIcon = styled.i`
  color: #D40F7D;
`;

const Link = styled.a`
  color: #D40F7D;
  display: block;
`;

const ContactMethods = ({ contractorPhone, contractorEmail, includeEmailSelf = false }) => {
  return (
    <Container>
      <LinkContainer>
        <H6>Phone Number</H6>
        <Link href={`tel:${contractorPhone}`} title={`Call ${contractorPhone}`}>{contractorPhone}</Link>
      </LinkContainer>
      <LinkContainer>
        <H6>Email</H6>
        {_.isArray(contractorEmail) ?
          contractorEmail.map(email => {
            return <Link href={`mailto:${email}`} title={`Email ${email}`}>{email}</Link>
          })
          :
          <Link href={`mailto:${contractorEmail}`} title={`Email ${contractorEmail}`}>{contractorEmail}</Link>
        }
      </LinkContainer>
      {/* {includeEmailSelf &&
        <LinkContainer>
          <H6>Save Price Estimation</H6>
          <IconContainer>
            <StyledIcon className="fa fa-envelope-o"></StyledIcon>
            <Link href={``} title={`Email self`}>Email Me A Copy</Link>
          </IconContainer>
        </LinkContainer>
      } */}
    </Container>
  );
};

export default ContactMethods;
